import { Component, OnInit } from '@angular/core';
import { APIService } from 'app/shared/api.service';
import { AQItem, AQService } from "../../shared/aq.service";

@Component({
  selector: 'app-report-airquality',
  templateUrl: './report-airquality.component.html',
  styleUrls: ['./report-airquality.component.css'],
  standalone: false
})
export class ReportAirqualityComponent implements OnInit {

  aqlist: AQItem[];
  options: any;
  overlays: any[] = [];
  aqSelected: AQItem;

  constructor(private apiService: APIService, private aqService: AQService) {
    this.options = {
      center: { lat: 53.7057599, lng: -1.912399 },
      zoom: 5
    };

    apiService.
      getAQForOrg()
      .then(aqlist => {
        this.aqlist = aqlist;
        this.build();
      });
  }

  build() {
    this.overlays = [];
    const sites = [...new Set(this.aqlist.map(item => item.siteId))];

    // Red 1
    // Online 2
    // Offline 3

    this.aqlist.sort(item => (item.isOffline) ? 1 : -1);
    this.aqlist.sort(item => (item.state === 'red' && !item.isOffline) ? -1 : 1);
  }

  ngOnInit(): void {

  }

}
